import { Grid, InputAdornment, TextField } from '@material-ui/core';
import React, { useState, useEffect } from 'react';
import { loadBaslandiJob, saveBaslandiJob } from 'src/utils/storage/StartWorkOrder';
import { setAlert } from 'src/store/actions/alertActions'
import { connect } from 'react-redux';

function Dezenfeksiyon(props) {
  const [m2, setM2] = useState(0);
  const [tutar, setTutar] = useState(250);

  useEffect(() => {
    let job = loadBaslandiJob()[0];
    setM2(job.DEZENFEKSIYON_METREKARE || 0);
    setTutar(job.DEZENFEKSIYON_TUTAR || 250);


    return () => {
      let job = loadBaslandiJob()[0];
      let arr = job.ISCILIKLER.filter(i => i.KUL_ISCILIK_KODU === '880');
      if (arr.length > 0) {
        if (job.DEZENFEKSIYON_METREKARE > 3000 && job.DEZENFEKSIYON_TUTAR < 3270) {
          props.setAlert('Dezenfeksiyon işçilik tutarı 3270 TL altında olmamalıdır. İşçilik tutarı güncellendi!..');
          job = {
            ...job,
            DEZENFEKSIYON_TUTAR: 3270
          };
        }
        let i = job.ISCILIKLER.indexOf(arr[0]);
        job.ISCILIKLER[i].FIYAT = parseFloat(job.DEZENFEKSIYON_TUTAR / 1.18, 2)
      }
      saveBaslandiJob(job);
    }
    // eslint-disable-next-line
  }, []);


  // Sadece m2 3000'den büyükse çalışacak!..
  const handleTutarChange = (event) => {
    const value = event.target.value;
    setTutar(value);
    let job = loadBaslandiJob()[0];
    job = {
      ...job,
      DEZENFEKSIYON_TUTAR: value
    };
    saveBaslandiJob(job);
  }


  const handleM2Change = (event) => {

    const value = event.target.value;
    setM2(value);
    let valueTutar = 250;
    if (value <= 200) {
      valueTutar = 250;
    } else if (value <= 300) {
      valueTutar = 330;
    } else if (value <= 400) {
      valueTutar = 440;
    } else if (value <= 500) {
      valueTutar = 550;
    } else if (value <= 600) {
      valueTutar = 660;
    } else if (value <= 700) {
      valueTutar = 770;
    } else if (value <= 800) {
      valueTutar = 880;
    } else if (value <= 900) {
      valueTutar = 990;
    } else if (value <= 1000) {
      valueTutar = 1100;
    } else if (value <= 2000) {
      valueTutar = 2200;
    } else if (value <= 3000) {
      valueTutar = 3300;
    } else {
      valueTutar = 3300 + (value - 3000) * 1.1;
    }
    setTutar(valueTutar);
    let job = loadBaslandiJob()[0];
    job = {
      ...job,
      DEZENFEKSIYON_METREKARE: value,
      DEZENFEKSIYON_TUTAR: valueTutar
    };
    saveBaslandiJob(job);
  }
  return (
    <div>
      <Grid container>
        <Grid item xs={4}>
          <TextField
            label={'m2'}
            name="DezenfektanAlan"
            type="number"
            InputLabelProps={{
              shrink: true,
            }}
            onChange={handleM2Change}
            variant="outlined"
            disabled={props.readonly}
            value={m2 || ''}
          />
        </Grid>
        <Grid item xs={1} />
        <Grid item xs={4}>
          <TextField
            label={'Tutar'}
            name="DezenfektanTutar"
            value={tutar || ''}
            onChange={handleTutarChange}
            type="number"
            InputLabelProps={{
              shrink: true,
            }}
            InputProps={{
              endAdornment: (
                <InputAdornment position="start">
                  ₺
                </InputAdornment>
              ),
            }}
            variant="outlined"
            disabled={props.readonly || m2 <= 3000}
          />
        </Grid>
      </Grid>
    </div>
  );
}


export default connect(
  state => state,
  { setAlert }
)(Dezenfeksiyon);
